import { logger } from '@services/logger/logger.service';
import { QueryClient } from '@tanstack/react-query';
import { READY_TO_SEND_COUNT_QUERY_KEY } from '../hooks/useReadyToSendCount.hook';

const DEBOUNCE_DELAY = 30000; // 30 seconds

let debounceTimeout: NodeJS.Timeout | undefined;

export const invalidateReadyToSendCount = (queryClient: QueryClient) => {
  // Clear previous timeout if exists
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
    logger.info('LOGIC', '[ReadyToSendCount] Debounce reset - new event received');
  }

  // Set new timeout - invalidate after debounce delay
  debounceTimeout = setTimeout(() => {
    logger.info('LOGIC', '[ReadyToSendCount] Invalidating cache after debounce');
    queryClient.invalidateQueries({
      queryKey: [READY_TO_SEND_COUNT_QUERY_KEY],
      refetchType: 'active',
    });
  }, DEBOUNCE_DELAY);
};
